import {
    options_mobile_status_ok,
    options_mobile_status_deviceBlocked,
    options_mobile_status_deviceWipePending,
    options_mobile_status_deviceWipeSucceeded,
    options_mobile_stateReason_global,
    options_mobile_stateReason_individual,
    options_mobile_stateReason_deviceRule,
    options_mobile_stateReason_upgrade,
    options_mobile_stateReason_policy,
    options_mobile_stateReason_externalCompliance,
    options_mobile_stateReason_externalEnrollment,
    options_mobile_stateReason_externallyManaged,
    options_mobile_stateReason_unfamiliarLocation,
    options_mobile_accessState_allowed,
    options_mobile_accessState_blocked,
    options_mobile_accessState_quarantined,
} from './getDevicesFromStatistics.locstring.json';
import loc from 'owa-localize';
import MobileDeviceStatistics from 'owa-service/lib/contract/MobileDeviceStatistics';
import { MobileDeviceDetailsType } from '../store/schema/MobileDeviceDetailsType';
import DeviceAccessStateReason from 'owa-service/lib/contract/DeviceAccessStateReason';
import DeviceAccessState from 'owa-service/lib/contract/DeviceAccessState';

function convertDeviceStatusToLocString(status: string): string {
    switch (status) {
        case 'DeviceOk':
            return loc(options_mobile_status_ok);
        case 'DeviceBlocked':
            return loc(options_mobile_status_deviceBlocked);
        case 'DeviceWipePending':
        case 'AccountOnlyDeviceWipePending':
            return loc(options_mobile_status_deviceWipePending);
        case 'DeviceWipeSucceeded':
        case 'AccountOnlyDeviceWipeSucceeded':
            return loc(options_mobile_status_deviceWipeSucceeded);
        default:
            return loc(options_mobile_status_ok);
    }
}

function convertDeviceStateReasonToLocString(stateReason: DeviceAccessStateReason): string {
    switch (stateReason) {
        case 'Global':
            return loc(options_mobile_stateReason_global);
        case 'Individual':
            return loc(options_mobile_stateReason_individual);
        case 'DeviceRule':
            return loc(options_mobile_stateReason_deviceRule);
        case 'Upgrade':
            return loc(options_mobile_stateReason_upgrade);
        case 'Policy':
            return loc(options_mobile_stateReason_policy);
        case 'ExternalCompliance':
            return loc(options_mobile_stateReason_externalCompliance);
        case 'ExternalEnrollment':
            return loc(options_mobile_stateReason_externalEnrollment);
        case 'ExternallyManaged':
            return loc(options_mobile_stateReason_externallyManaged);
        case 'UnfamiliarLocation':
            return loc(options_mobile_stateReason_unfamiliarLocation);
        default:
            return '';
    }
}

function convertDeviceAccessStateToLocString(accessState: DeviceAccessState): string {
    switch (accessState) {
        case 'Allowed':
            return loc(options_mobile_accessState_allowed);
        case 'Blocked':
            return loc(options_mobile_accessState_blocked);
        case 'Quarantined':
            return loc(options_mobile_accessState_quarantined);
        default:
            return '';
    }
}

export function getDevicesFromStatistics(
    deviceStatistics: MobileDeviceStatistics[]
): MobileDeviceDetailsType[] {
    return deviceStatistics.map(
        (device): MobileDeviceDetailsType => {
            return {
                identity: device.Identity,
                deviceName: device.DeviceFriendlyName,
                phoneNumber: device.DevicePhoneNumber,
                firstSyncTime: device.FirstSyncTime,
                lastSyncTime: device.LastSyncAttemptTime,
                lastSuccessSync: device.LastSuccessSync,
                status: convertDeviceStatusToLocString(device.Status),
                folderSynced: device.NumberOfFoldersSynced,
                deviceModel: device.DeviceModel,
                mobileNetwork: device.DeviceMobileOperator,
                deviceType: device.DeviceType,
                deviceID: device.DeviceId,
                deviceIMEI: device.DeviceImei,
                deviceOS: device.DeviceOS,
                deviceLanguage: device.DeviceOSLanguage,
                userAgent: device.DeviceUserAgent,
                accessState: convertDeviceAccessStateToLocString(device.DeviceAccessState),
                accessSetBy: convertDeviceStateReasonToLocString(device.DeviceAccessStateReason),
                clientType: device.ClientType,
                protocolVersion: device.ClientVersion,
            };
        }
    );
}
